import { Services, isValidPassword } from '@sigma-frontend-libs/commons'

import { generatePassword, proxy } from '@/utils'

import render from './render'

export default {
  name: 'UsersBasicFormPassword',

  mixins: [ proxy() ],

  props: {
    errors: {
      type: Object,
      default: () => {
        return {}
      }
    },

    isNew: Boolean,
    isRegistration: Boolean,

    saveSuccessKey: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      editable: false,
      passwordVisibility: true
    }
  },

  computed: {
    error() {
      if (this.proxy && !isValidPassword(this.proxy)) {
        return this.getTranslate('errors.validation.types.invalid', {
          field: this.getTranslate(`${Services.users}.labels.password`).toLowerCase()
        })
      }
    },
    hint() {
      if (this.isRegistration) {
        return this.getTranslate(`${Services.users}.hints.password`)
      }
    },
    autocomplete() {
      if (this.isRegistration) {
        return 'new-password'
      }

      return 'current-password'
    }
  },

  watch: {
    saveSuccessKey() {
      if (this.isNew || this.isRegistration) {
        return
      }

      this.editable = false
      this.passwordVisibility = true
    }
  },

  methods: {
    passwordGenerator() {
      this.passwordVisibility = false
      this.proxy = generatePassword({
        length: 8,
        numbers: true,
        symbols: false,
        uppercase: true,
        strict: true
      })
    }
  },

  render
}
